import script from "./addjiaoxuesheji.vue?vue&type=script&setup=true&lang=js"
export * from "./addjiaoxuesheji.vue?vue&type=script&setup=true&lang=js"

import "./addjiaoxuesheji.vue?vue&type=style&index=0&id=782e94de&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782e94de"]])

export default __exports__